module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/9c047823333671f288e92ea69c6ae417.png";